// ui
import { Icon, IconProps } from "@chakra-ui/react";

export const ChevronLeftIcon = (props: IconProps) => (
  <Icon viewBox="0 0 16 32" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.3156 1.07984C15.847 1.60289 15.8537 2.45764 15.3306 2.98897L2.91708 15.5989C2.65238 15.8678 2.65238 16.216 2.91708 16.4849L15.3306 29.0948C15.8537 29.6262 15.847 30.4809 15.3156 31.004C14.7843 31.527 13.9296 31.5203 13.4065 30.989L0.992965 18.379C-0.306249 17.0593 -0.306249 15.0245 0.992964 13.7048L13.4065 1.09482C13.9296 0.563493 14.7843 0.556784 15.3156 1.07984Z"
      fill="currentColor"
    />
  </Icon>
);
